module.exports = __webpack_public_path__ + "static/media/mail_inverted_hover.57007ca2.svg";